//frontend/src/dropdownMap/cb_villagers_dropdownFieldMapping.js

export const dropdownFieldsByIdx = {
    9: "ActivityType",
    10: "SpecializedTopic",
    12: "ConductedBy",
    13: "ActivityCode",
    17: "Gender",
    18: "Responsibility",
    19: "FromWhichLevel",
    21: "PovertyLevel",
    22: "PWDStatus",
    23: "APGMember",
};

// Specialized Topic is a cascading dropdown: each itemcode is scoped to exactly one
// Activity Type via the DB's choice_filter column. Grouped here as [code, LA label, EN label].
const SPECIALIZED_TOPIC_GROUPS = {
    "1_tot": [
        ["tot1", "ຝຶກຄູຝຶກ ການປຸງແຕ່ງອາຫານ", "TOT on domestic food processing for VNF"],
        ["tot2", "ຝຶກຄູຝຶກ ສຳລັບ 4 ບົດຮຽນ ໃຫ້ແກ່ ຜູ້ອໍານວາຍຄວາມສະດວກຂັ້ນບ້ານ", "TOT on 4 modules for  village facilitator (VF)"],
        ["tot3", "ຝຶກຄູຝຶກສາທິດການແຕ່ງກິນ ໃຫ້ແກ່ ຜອບ", "TOT on Cooking demonstration session for VF"],
        ["tot4", "ຝຶກຄູຝຶກການຢ້ຽມຢາມສວນຄົວແບບມີສວ່ນຮ່ວມ ໃຫ້ແກ່ ຜອບ", "TOT Participatory HG visit for VF"],
        ["tot5", "ຝຶກຄູຝຶກ ຄວາມຮູ້ພື້ນຖານດ້ານທຸລະກິດ ໃຫ້ແກ່ ຜອບ", "TOT on business literacy training"]
    ],
    "2_tc": [
        ["tc_1", "ເຮືອນຮົມ", "Vegetable in greenhouse"],
        ["tc_2", "ປຸກຜັກ", "Vegetable growing"],
        ["tc_3", "ປູກຜັກທຽມ", "Garlic growing"],
        ["tc_4", "ປຸກເຂົ້າ", "Rice growing"],
        ["tc_5", "ປູກຖົ່ວຍາວ", "Long been growing"],
        ["tc_6", "ປູກເຫັດ", "Mushroom"],
        ["tc_7", "ປູກ​ຫມາກ​ຂ່າ", "Galangal"],
        ["tc_8", "ປູກຫອມປ້ອມ ນອກລະດູການ", "Coriander - off - season growing"],
        ["tc_9", "ປູກຫຍ້າລ້ຽງສັດ", "Forage plantation"],
        ["tc_10", "ໄມ້ໃຫ້ຫມາກ", "Horticulture"],
        ["tc_11", "ປູກ​ໝາກ​ແຫນ່ງ", "Cardamum"],
        ["tc_12", "ຜະລິດຊາ", "Tea production"],
        ["tc_13", "ກາເຟ", "Coffee production"],
        ["tc_14", "ປູກແຂມ", "Broom grass plantation"],
        ["tc_15", "ເຕັກນິກການກຳຈັດສັດຕູພືດ", "Crop desease management techniques"],
        ["tc_16", "ປູກຫວາຍຂົມ", "Bitter ratten growing"],
        ["tc_17", "ປູກຫນໍ່ຂົມ", "Bitter bamboo growing"],
        ["tc_18", "ຫນໍ່ໄມ້ລ້ຽງນ້ອງ", "Bamboo growing"],
        ["tc_19", "ຄຸ້ມຄອງປ່າຫນໍ່ຂົມ", "Nor Khom bamboo area management"],
        ["tc_20", "ຄຸ້ມຄອງຫນໍ່ຫຼອຍ", "Nor Khom bamboo area management"],
        ["tc_21", "ຄຸ້ມຄອງປ່າຫມາກຈອງບານ", "Malva nut area management"],
        ["tc_22", "ປູກຫນໍບົງຫວານ", "Nor bong vahn bamboo growing"],
        ["tc_23", "ສ້າງສວນກ້າ", "Nursery establishment"]
    ],
    "2_tl": [
        ["tl_1", "ລ້ຽງສັດປິກ", "Poultry raising"],
        ["tl_2", "ລ້ຽງແບ້", "Goat raising"],
        ["tl_3", "ລ້ຽງໝູ", "Pig raising"],
        ["tl_4", "ລ້ຽງປາ", "Fish raising"],
        ["tl_5", "ລ້ຽງກົບ", "Frog raising"],
        ["tl_6", "ລ້ຽງສັດ", "Livestock raising"],
        ["tl_7", "ສັດຕະວະແພດ", "Veterinary practices"],
        ["tl_8", "ການທອມສັດ", "Cattle fattening"],
        ["tl_9", "ລ້ຽງເຜີ້ງ", "Bee Keeping"],
        ["tl_10", "ເຕັກນິກການປູກ+ລ້ຽງ", "Crop and livestock techniques"],
        ["tl_11", "ການສ້າງວັງສະຫງວນ", "Fishery conservation area establishment"],
        ["tl_12", "ການລ້ຽງປາດຸກໃນຫນອງຜ້າຢາງ", "Catfish raising in plastic artificial pond"],
        ["tl_13", "ການລ້ຽງກົບຢູ່ພື້ນທີປູກຜັກສວນຄົວ", "Frog raising in home garden"],
        ["tl_14", "ການຜະລິດລູກປານິນໃນກະຊັງ", "Tirapia fingerling production"]
    ],
    "2_tl_tc": [
        ["tl_tc_1", "ເຕັກນິກການປູກ+ລ້ຽງ", "Crop and livestock techniques"]
    ],
    "2_training": [
        ["training_1", "ການປຸງແຕ່ງອາຫານ ໃນຄົວເຮືອນ", "Food processing (Domestic) training"],
        ["training_2", "ການປຸງແຕ່ງ ແລະ ຄວາມປອດໄພ ຂອງອາຫານ", "Food processing & Food safety (commercial)"],
        ["training_3", "ການຄຸ້ມຄອງບໍລິຫານທະນາຄານເຂົ້າ", "Village Rice banks Mgt. techniques"],
        ["training_4", "ຝຶກຄູຝຶກເຕັກນິກການຮັກສາຜົນຜະລິດຫຼັງການເກັບກ່ຽວ", "Post- harvest training on village level"],
        ["training_5", "ຝຶກອົບຮົມການລ້ຽງໄກ່ພັນໃຂ່", "Hybrid chicken raising techniques"],
        ["training_6", "ຝຶກດ້ານພື້ນຖານເຕັກນິກກະສິກໍາ ໃຫ້ແກ່ວິຊາການບ້ານ, ອພບ, ອສບ", "Agriculture training/refresher course for VNF, LF, VVW"],
        ["training_7", "ປະຕິບັດລະບົບການຮຽນຮູ້ດ້ານບົດບາດຍິງຊາຍຜ່ານກິດຈະກຳ", "Implementation of GALS at village level"],
        ["training_8", "ຝຶກອົບຮົມ ກ່ຽວກັບຄວາມສຳຄັນ ແລະ ຂະບວນການສ້າງຕັ້ງກຸ່ມ", "Knowledge on importance and APG formulation process"],
        ["training_9", "ເຕັກນິກການຄຸ້ມຄອງບໍລິຫານກຸ່ມ", "APG management techniques for villagers"],
        ["training_10", "ການຄຸ້ມຄອງທຸລະກິດ/ກິດຈະກຳສ້າງລາຍຮັບ", "Business Mgt./ Income generating activites"],
        ["training_11", "ການບໍລິການດ້ານການພັດທະນາທຸລະກິດ ສຳລັບວິສາຫະກິດ ຢູ່ຊົນນະບົດ", "Business Devpt. Services for Rural enteprices (for MSME)"],
        ["training_12", "ຝຶກອົບຮົມ 4 ບົດບົດຮຽນ ໃຫ້ຊາວບ້ານ", "Training on 4 modules for  villages"],
        ["training_13", "ອື່ນໆ", "Others"]
    ],
    "3_visit": [
        ["visit_1", "ທັດສະນະສຶກການຄຸ້ມຄອງກຸ່ມຜະລິດ", "Study/Exchange Visits APG Mgt."],
        ["visit_2", "ທັດສະນະສຶກການ ການເຮັດສວນຄົວ", "Study/Exchange Visits Household gardening"],
        ["visit_3", "ທັດສະນະສຶກການຈັດການສວນຫຍ້າອາຫານສັດ", "Study/Exchange Visits Forage Mgt."]
    ],
    "4_onjobtraining": [
        ["onjob_1", "ນຳພາສະມາຊິກກຸ່ມ ຂຽນແຜນທຸລະກິດ", "OJT On APG business proposal for APG Member"],
        ["onjob_2", "ນໍາພາສະມາຊິກກຸ່ມ ປະກອບເອກະສານຈັດຊື້ ກຸ່ມ", "APG procurement documents for APG Member"]
    ],
    "5_onsite_demo": [
        ["demo_1", "ສາທິດການປູກເຫັດ", "Mushroom production"],
        ["demo_2", "ສາທິດການປູກຖົ່ວຍາວ", "Long bean cultivation technique"],
        ["demo_3", "ສາທິດການປູກຜະລິດຫຍ້າອາຫານສັດ", "Forage Production and processing (Silage)"],
        ["demo_4", "ສາທິດປູກພືດຜັກຕາມລະດູການ", "Seasonal Vegetable production"],
        ["demo_5", "ສາທິດການປູກເຂົ້າ", "Rice growing"],
        ["demo_6", "ສາທິດການປູກພືດຜັກ ໃນເຮືອນຮົ່ມ", "Veg growing in sheding house (greenhouse)"],
        ["demo_7", "ສາທິດການປູກຜັກທຽມ", "Garlic production"],
        ["demo_8", "ສາທິດການປູກຫອມປ້ອມນອກລະດູ", "Coriander production-off season"],
        ["demo_9", "ສາທິດການຜະລິດລູກແບ້", "Goat breeding/raising"],
        ["demo_10", "ສາທິດການຜະລິດລູກໝູ", "Local pig breeding/ raising"],
        ["demo_11", "ສາທິດການລ້ຽງປາດຸກໃນໜອງຜ້າຢາງ", "Catfish raising in plastic artificial pond/ integrated with HG"],
        ["demo_12", "ສາທິດການລ້ຽງກົບ+ສວນຄົວ", "Frog raising integrated with home garden"],
        ["demo_13", "ສາທິດການລ້ຽງປາ + ລ້ຽງໝູ", "Fish farming integrated with pig raising"],
        ["demo_14", "ສາທິດການຜະລິດລູກປານິນ", "Tilapia fingerling production in cage"],
        ["demo_15", "ສາທິດການທອມງົວ", "Cattle fattening"],
        ["demo_16", "ສາທິດການລ້ຽງໝູລາດ", "Local pig raising"],
        ["demo_17", "ສາທິດການລ້ຽງໄກ່ລາດ", "Local chicken raising"],
        ["demo_18", "ການລົງຮຽນຮູ້ ກັບຈຸດສາທິດ", "On-the- job Training (OJT) in Demo plots"]
    ]
};

// Build the flat SpecializedTopic dropdown option set plus a code -> parent-ActivityType lookup
// used by the frontend to filter the option list down to the currently selected Activity Type.
const SpecializedTopic = { internal: [], LA: {}, EN: {}, groupBy: {} };
Object.entries(SPECIALIZED_TOPIC_GROUPS).forEach(([activityTypeCode, items]) => {
    items.forEach(([code, la, en]) => {
        SpecializedTopic.internal.push(code);
        SpecializedTopic.LA[code] = la;
        SpecializedTopic.EN[code] = en;
        SpecializedTopic.groupBy[code] = activityTypeCode;
    });
});

export const dropdownOptions = {
    // Gender: {
    //     internal: ["_male", "_female"],
    //     LA: { "_male": "ຊາຍ", "_female": "ຍິງ" },
    //     EN: { "_male": "Male", "_female": "Female" }
    // },

    //internal values should match database stored values
    //LA and EN values are for display purpose

    ActivityType: {
        internal: ["1_tot", "2_tc", "2_tl", "2_tl_tc", "2_training", "3_visit", "4_onjobtraining", "5_onsite_demo"],
        LA: {
            "1_tot": "1",
            "2_tc": "2TC",
            "2_tl": "2TL",
            "2_tl_tc": "2TL+TC",
            "2_training": "2",
            "3_visit": "3",
            "4_onjobtraining": "4",
            "5_onsite_demo": "5"
        },
        EN: {
            "1_tot": "1",
            "2_tc": "2TC",
            "2_tl": "2TL",
            "2_tl_tc": "2TL+TC",
            "2_training": "2",
            "3_visit": "3",
            "4_onjobtraining": "4",
            "5_onsite_demo": "5"
        }
    },
    FromWhichLevel: {
        internal: ["__3"],
        LA: { "__3": "ບ້ານ" },
        EN: { "__3": "Vill. Level" }
    },
    SpecializedTopic,
    ConductedBy: {
        internal: ["npco", "wfp", "pafo", "dafo", "gst", "maf", "nafri", "daec"],
        LA: { "npco": "ຫ້ອງການປະສານງານສູນກາງ", "wfp": "ອົງການອາຫານໂລກ", "pafo": "ພະແນກ ກປ ແຂວງ", "dafo": "ຫ້ອງການ ກປ  ເມືອງ", "gst": "ທີມງານຊ່ວຍເຫຼືອກຸ່ມ", "maf": "ກະຊວງ ກປ", "nafri": "ສະຖາບັນຄົ້ນຄວ້າ ກປ ແລະ ພັດທະນາຊົນນະບົດ", "daec": "ກົມສົ່ງເສີມກະສິກຳ ແລະ ສະຫະກອນ" },
        EN: { "npco": "NPCO", "wfp": "WFP", "pafo": "PAFO", "dafo": "DAFO", "gst": "GST", "maf": "MAF", "nafri": "NAFRI", "daec": "DAEC" }
    },
    ActivityCode: {
        internal: ["1A.1", "1A.2", "1A.3a", "1A.3b", "1A.4", "1A.5a", "1A.5b", "1B.Act6", "1B.Act7", "1B.Act8", "2Act1", "2Act2", "2Act3", "3Act1a", "3Act1b", "3Act2"],
        LA: { "1A.1": "1A.1", "1A.2": "1A.2", "1A.3a": "1A.3a", "1A.3b": "1A.3b", "1A.4": "1A.4", "1A.5a": "1A.5a", "1A.5b": "1A.5b", "1B.Act6": "1B.Act6", "1B.Act7": "1B.Act7", "1B.Act8": "1B.Act8", "2Act1": "2Act1", "2Act2": "2Act2", "2Act3": "2Act3", "3Act1a": "3Act1a", "3Act1b": "3Act1b", "3Act2": "3Act2" },
        EN: { "1A.1": "1A.1", "1A.2": "1A.2", "1A.3a": "1A.3a", "1A.3b": "1A.3b", "1A.4": "1A.4", "1A.5a": "1A.5a", "1A.5b": "1A.5b", "1B.Act6": "1B.Act6", "1B.Act7": "1B.Act7", "1B.Act8": "1B.Act8", "2Act1": "2Act1", "2Act2": "2Act2", "2Act3": "2Act3", "3Act1a": "3Act1a", "3Act1b": "3Act1b", "3Act2": "3Act2" }
    },
    Gender: {
        internal: ["Male", "Female"],
        LA: { "Male": "ຊາຍ", "Female": "ຍິງ" },
        EN: { "Male": "Male", "Female": "Female" }
    },
    Responsibility: {
        internal: [
            "option_1", "option_2", "lwu", "youth", "vnf", "villager", "senior_person", "lf", "vvw", "vnc", "vrbc", "msme"
        ],

        LA: {
            "option_1": "ນາຍບ້ານ",
            "option_2": "ຮອງ ນາຍບ້ານ",
            "lwu": "ສະຫະພັນແມ່ຍິງ",
            "youth": "ຊາວໜຸ່ມ",
            "vnf": "ຜູ້ອຳນວຍຄວາມສະດວກວຽກໂພຊະນາການຂັ້ນບ້ານ",
            "villager": "ຊາວບ້ານ",
            "senior_person": "ຜູ້ອາວຸໂສ (ເຖົ້າແກ່ ແນວໂຮມ)",
            "lf": "ກະສິກອນຕົວແບບ",
            "vvw": "ສັດຕະວະແພດບ້ານ",
            "vnc": "ຄະນະໂພຊະນາການຂັ້ນບ້ານ",
            "vrbc": "ຄະນະກໍາມະການຄຸ້ມຄອງທະນາຄານເຂົ້າ",
            "msme": "ຈຸລະວິສາຫະກິດ, ວສກ ນ້ອຍ, ກາງ"
        },

        EN: {
            "option_1": "V-head",
            "option_2": "VD-head",
            "lwu": "LWU",
            "youth": "Youth",
            "vnf": "VNF",
            "villager": "Villager",
            "senior_person": "Senior person",
            "lf": "LF",
            "vvw": "VVW",
            "vnc": "VNC",
            "vrbc": "VRBC",
            "msme": "MSME"
        }
    },

    PovertyLevel: {
        internal: ["p", "np"],
        LA: { "p": "P", "np": "NP" },
        EN: { "p": "P", "np": "NP" }
    },

    PWDStatus: {
        internal: ["no", "yes"],
        LA: { "no": "No", "yes": "Yes" },
        EN: { "no": "No", "yes": "Yes" }
    },

    APGMember: {
        internal: ["no", "yes"],
        LA: { "no": "No", "yes": "Yes" },
        EN: { "no": "No", "yes": "Yes" }
    }
};

// Reverse mapping: LA → _male etc.
// export const dropdownReverseMap = {};
// Object.keys(dropdownOptions).forEach(field => {
//     dropdownReverseMap[field] = { LA: {}, EN: {} };
//     const opts = dropdownOptions[field];
//     opts.internal.forEach(intVal => {
//         dropdownReverseMap[field].LA[opts.LA[intVal]] = intVal;
//         dropdownReverseMap[field].EN[opts.EN[intVal]] = intVal;
//     });
// });
export const dropdownReverseMap = {};
Object.keys(dropdownOptions).forEach(field => {
    dropdownReverseMap[field] = { LA: {}, EN: {} };
    const opts = dropdownOptions[field];
    opts.internal.forEach(intVal => {
        const strVal = String(intVal); // force string
        dropdownReverseMap[field].LA[opts.LA[strVal]] = strVal;
        dropdownReverseMap[field].EN[opts.EN[strVal]] = strVal;
    });
});

// SpecializedTopic labels repeat across different Activity Type groups (e.g. "Rice growing" is
// both tc_4 (2_tc) and demo_5 (5_onsite_demo)), so a flat label -> code map would collide and
// pick the wrong one. Reverse map is scoped instead: [language][activityTypeCode][label] -> code.
dropdownReverseMap.SpecializedTopic = { LA: {}, EN: {} };
SpecializedTopic.internal.forEach(code => {
    const activityTypeCode = SpecializedTopic.groupBy[code];
    ['LA', 'EN'].forEach(lang => {
        if (!dropdownReverseMap.SpecializedTopic[lang][activityTypeCode]) {
            dropdownReverseMap.SpecializedTopic[lang][activityTypeCode] = {};
        }
        dropdownReverseMap.SpecializedTopic[lang][activityTypeCode][SpecializedTopic[lang][code]] = code;
    });
});
